import { useReactFlow } from '@xyflow/react';
import { useKeyboardShortcut } from '@/features/canvas/engine/hooks/use-keyboard-shortcut';

interface GroupShortcutActions {
  onGroup: (ids: string[]) => void;
  onUngroup: (frameIds: string[]) => void;
}

export function useGroupShortcut({ onGroup, onUngroup }: GroupShortcutActions) {
  const { getNodes } = useReactFlow();
  useKeyboardShortcut(
    { key: 'g', meta: true },
    (e) => {
      e.preventDefault();
      const selected = getNodes().filter((n) => n.selected);

      if (e.shiftKey) {
        const frameIds = selected.filter((n) => n.type === 'frame').map((n) => n.id);
        if (frameIds.length === 0) return;
        onUngroup(frameIds);
      } else {
        const groupable = selected.filter((n) => n.type !== 'frame').map((n) => n.id);
        if (groupable.length < 2) return;
        onGroup(groupable);
      }
    },
  );
}
